import React from 'react'
import "animate.css/animate.min.css";
import ScrollAnimation from 'react-animate-on-scroll';
import { TestiMonailItem ,TestMonailItemText ,TestMonailItemRating} from './Style';

export default function TestiMonail() {
    return (
        <ScrollAnimation animateIn="animate__fadeIn">
            <TestiMonailItem>
                <img src={"/images/bg.jpg"} />
                <TestMonailItemText>
                    <h6>John Alan</h6>
                    <p>Applied Researcher</p>
                    <p>
                        I met so many interesting people over the last couple of
                        months, who proved to stay ahead of the modern technologies
                        in the world of branding and web design.
                        I loved working with you all, thank you so much!
                    </p>
                </TestMonailItemText>
                <TestMonailItemRating>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                </TestMonailItemRating>
            </TestiMonailItem>
        </ScrollAnimation>
    )
}
